export default "/en/catalog/@slug";
